import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useMyAvatar } from "@/hooks/useMyAvatar";
import { useProfilePhotoUrl } from "@/hooks/useProfilePhotoUrl";
import { cn } from "@/lib/utils";

interface NavProfileAvatarProps {
  /** Prefer the company logo (B2B accounts) over the personal photo */
  preferCompany?: boolean;
  className?: string;
}

/** Small round avatar for the navigation bar. Falls back to initials. */
export function NavProfileAvatar({ preferCompany = false, className }: NavProfileAvatarProps) {
  const { photoUrl, companyLogoUrl, initials } = useMyAvatar();
  const source = preferCompany ? companyLogoUrl || photoUrl : photoUrl;
  const resolved = useProfilePhotoUrl(source);

  return (
    <Avatar className={cn("h-9 w-9 border border-border", className)}>
      {resolved && <AvatarImage src={resolved} alt="Mijn profielfoto" className="object-cover object-center" />}
      <AvatarFallback className="bg-primary/10 text-primary text-xs font-medium">{initials}</AvatarFallback>
    </Avatar>
  );
}

export default NavProfileAvatar;
